import Skeleton from "react-loading-skeleton";
import ReleaseCard from "../ReleaseCard";
import { ReleasesList as StyledReleasesList, ReleaseSkeleton } from "./styled";

export const ReleasesList = ({
  releases,
  releasesPodcast,
  isLoading,
  podcasts,
  showLikeBtn = false,
  inPodcast,
  onClickCardRelease,
}) => {
  return (
    <StyledReleasesList>
      {isLoading
        ? Array.from({ length: 3 }).map((_, index) => (
            <ReleaseSkeleton as={Skeleton} key={index} />
          ))
        : releases?.map((release, index) => {
            const releasePodcast =
              releasesPodcast ??
              podcasts.find((podcast) => podcast.id === release.podcastId);
            return (
              <ReleaseCard
                playlistReleases={releases}
                release={release}
                showPodcastInfo
                releasePodcast={releasePodcast}
                index={index || 1}
                key={release.id}
                showLikeBtn={showLikeBtn}
                inPodcast={inPodcast}
                onClickCard={onClickCardRelease}
              />
            );
          })}
    </StyledReleasesList>
  );
};
